var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2212 22.8168C17.744 22.8168 22.2212 18.3396 22.2212 12.8168C22.2212 7.29392 17.744 2.81677 12.2212 2.81677C6.69834 2.81677 2.22119 7.29392 2.22119 12.8168C2.22119 18.3396 6.69834 22.8168 12.2212 22.8168ZM6.57474 14.1703L9.86764 17.4632C10.0629 17.6585 10.3795 17.6585 10.5747 17.4632L17.8689 10.1691C18.0637 9.97429 18.0642 9.65867 17.8701 9.46321L17.1647 8.75282C16.9697 8.55638 16.6521 8.55581 16.4564 8.75156L10.2212 14.9868L7.98474 12.7589C7.78937 12.5643 7.47332 12.5646 7.27832 12.7596L6.57474 13.4632C6.37948 13.6585 6.37948 13.975 6.57474 14.1703Z",
    fill: "#0097A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolid);
export default __webpack_public_path__ + "static/media/check-circle-solid.f9f4e5326e3fd2fdfaa7d811317ad843.svg";
export { ForwardRef as ReactComponent };